import React     from 'react';
import { Link }  from "react-router-dom";

export default function Breadcrumbs(props) {
    return (<nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-2">
            <li className="breadcrumb-item"><Link to="/">Все проекты</Link></li>
            { props.parent_id !== undefined &&
                <li className="breadcrumb-item"><Link to={"/project/" + props.parent_id}>{props.parent_name}</Link></li>
            }
            <li className="breadcrumb-item active" aria-current="page">{props.name}</li>
        </ol>
    </nav>);
}
